<div class="card">
  <div class="card-body">
    <!-- Search/Filter Form -->
    <div class="mb-4">
      <form class="row g-3 align-items-center" (ngSubmit)="applyNameFilter()">
        <div class="col-md-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'Organization.OrganizationSearchName' | localize }}</mat-label>
            <input
              matInput
              type="text"
              [(ngModel)]="searchName"
              name="searchName"
              (keyup.enter)="applyNameFilter()">
            <button
              matSuffix
              mat-icon-button
              type="submit"
              aria-label="Search">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </form>
    </div>

    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" matSort class="w-100">
        <!-- ID Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="id">{{ getColumnHeader('id') | localize }}</th>
          <td mat-cell *matCellDef="let org">{{ org.id }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="name">{{ getColumnHeader('name') | localize }}</th>
          <td mat-cell *matCellDef="let org">{{ org.name }}</td>
        </ng-container>

        <!-- Type Column -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="type">{{ getColumnHeader('type') | localize }}</th>
          <td mat-cell *matCellDef="let org">{{ org.type }}</td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ getColumnHeader('actions') | localize }}</th>
          <td mat-cell *matCellDef="let org">
            <button
              mat-icon-button
              color="primary"
              (click)="viewOrganizationDetails(org.id)"
              *ngIf="permissionService.hasPermission('VIEW_ORGANISATION')">
              <i-tabler name="eye"></i-tabler>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <div *ngIf="isLoading" class="text-center my-4">
        <mat-spinner diameter="40" class="mx-auto"></mat-spinner>
      </div>

      <div *ngIf="!isLoading && dataSource.data.length === 0" class="text-center my-4">
        {{ 'Organization.NoOrganizations' | localize }}
      </div>

      <mat-paginator
        [length]="totalItems"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPageChange($event)"
        showFirstLastButtons
        aria-label="Select page of organizations">
      </mat-paginator>
    </div>
  </div>
</div>
